import React, { useContext } from 'react'
import styled from 'styled-components'
import useDarkMode from 'use-dark-mode'
import { useTransition, animated, config } from 'react-spring'

const StyledButton = styled.button`
  font-size: 2vw;
  line-height: 1;
  cursor: pointer;
`

import { DarkModeContext } from '../common/layout/Layout'

function DarkModeToggle() {
    const darkModeValue = useContext(DarkModeContext)
    const darkMode = useDarkMode(darkModeValue)
    const transitions = useTransition(darkModeValue, null, {
        from: {
            position: `absolute`,
            right: `3vw`,
            opacity: 0,
        },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: config.slow,
    })
    return transitions.map(({ item, key, props }) => item ? (
        <animated.div style={props} key={key}>
            <StyledButton type="button" onClick={darkMode.toggle}>
          ☀
            </StyledButton>
        </animated.div>
    ) : (
        <animated.div style={props} key={key}>
            <StyledButton type="button" onClick={darkMode.toggle}>
          ☾
            </StyledButton>
        </animated.div>
    )
    )
}

export default DarkModeToggle
